import { X } from "lucide-react";

export default function AddShopModal({ isOpen, closeModal, qrImgSrc }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[60]">
      <div className="bg-white rounded-lg max-w-md w-full relative">
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100 transition-colors"
          aria-label="Đóng"
        >
          <X size={20} />
        </button>

        <div className="p-5">
          <h2 className="text-lg font-semibold text-center text-gray-900 mb-1.5">
            Thêm Zalo mới
          </h2>

          <p className="text-center text-[12px] text-gray-500 mb-5">
            Đăng nhập tài khoản Zalo để kết nối với ứng dụng Zalo Web
          </p>

          <div className="flex justify-center mb-4">
            <div className="relative w-44 h-44 border border-gray-200 rounded-md shadow-sm bg-white">
              <img
                src={qrImgSrc}
                alt="QR Code"
                className="p-2 w-full h-full object-contain"
              />
            </div>
          </div>

          <div className="flex items-center justify-center gap-1.5 mb-3">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-500 animate-pulse" />
            <span className="text-[12px] text-blue-600 font-medium">
              Đang chờ bạn quét mã...
            </span>
          </div>

          <div className="text-center space-y-1">
            <p className="text-[12px] font-medium text-gray-700">
              Chỉ dùng để đăng nhập Zalo trên máy tính
            </p>
            <p className="text-[11px] text-gray-500">
              Sử dụng ứng dụng Zalo trên điện thoại để quét mã QR
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
